export type IInitWYSIWYG = IDCA.IGenericFunc;

export function _initWYSIWYG(): void {
  // Remove formatting during paste
  function PasteButton() {
    const { ui } = ($ as any).summernote;
    const button = ui.button({
      className: 'strip-formatting-button',
      contents: '<i class="fa fa-paste"/>',
      click(e: JQuery.ClickEvent<IjQueryElmOrHtmlElm>) {
        const $button = $(e.currentTarget);
        const $textareaWrapper = $button.closest('.textarea-wrapper');
        $button.toggleClass('active');
        $textareaWrapper.data('strip-formatting', !$textareaWrapper.data('strip-formatting'));
      },
      tooltip: 'Supprimer la mise en forme lors du collage.',
    });
    return button.render();
  }

  // Remove invalid formatting
  /*
const RemoveInvalidButton = function(context) {
  const ui = $.summernote.ui;
  const button = ui.button({
    contents: '<i class="fa fa-ban"/>',
    tooltip: 'Supprimer les caractères non valides.',
    click: function(e) {
      const $button = $(e.currentTarget);
      const $formGroup = $button.closest('.form-group');
      const $form = $formGroup.closest('form');
      const suffix = $form.data('suffix');
      const fieldId = $formGroup.data('field-id');
      const $textarea = $formGroup.find('textarea');
      const val = $textarea.val();
      const FormsApi = window.DexeroCoreApp.getAppService('FormsApi');
      const userOptions = window.DexeroCoreApp.getUserOptions();
      const { ownerIdentifier, formIdentifier } = userOptions;
      const fieldIdentifier = window.DexeroCoreApp.getFieldProperties(fieldId.toString().replace(suffix, ''), suffix).identifier;
      FormsApi.getCleanedHtml(ownerIdentifier, formIdentifier, fieldIdentifier, {body: val}, function(error, data) {
        if (!error) {
          const cleanVal = data.body;
          context.invoke('code', cleanVal);
        } else {
          if(window.console) {
            console.warn('Cannot insert cleaned value.');
          }
        }
      });
    }
  });
  return button.render();
};
*/

  const textareas = $('textarea[convert_this=true]');
  $(textareas).each((_, textarea) => {
    const $textarea = $(textarea);
    if ($textarea.next('.note-editor').length > 0) {
      return;
    }
    const $formGroup = $textarea.closest('.form-group');
    const $textareaWrapper = $formGroup.find('.textarea-wrapper');
    const id = $textarea.attr('id');
    const requried = $textarea.prop('required');
    const warning = !!$textarea.data('empty-warning');
    const readOnly = $textarea.prop('readonly');
    const lang = window.language === 'fr' ? 'fr-FR' : 'en-EN';
    const placeholder = $textarea.attr('placeholder') || null;

    ($textarea as any).summernote({
      buttons: {
        paste: PasteButton,
      },
      callbacks: {
        onPaste(e: any) {
          const stripFormatting = $textareaWrapper.data('strip-formatting');
          if (stripFormatting) {
            const bufferText = (
              (e.originalEvent || e).clipboardData || window.clipboardData
            ).getData('Text');
            e.preventDefault();
            if (!window.DexeroCoreApp.browser.msie) {
              ($textarea as any).summernote('editor.saveRange');
            }
            ($textarea as any).summernote('editor.restoreRange');
            ($textarea as any).summernote('editor.focus');
            ($textarea as any).summernote('editor.insertText', bufferText);
          }
        },
      },
      codemirror: {
        htmlMode: true,
        lineNumbers: true,
        mode: 'text/html',
      },
      dialogsInBody: true,
      fontSizes: ['8', '9', '10', '11', '12', '14', '18', '24', '36', '48', '64', '82', '150'],
      height: 200,
      lang,
      placeholder,
      tabsize: 2,
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['style', ['fontname']],
        ['font', ['strikethrough', 'superscript', 'subscript']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']],
        ['table', ['table']],
        ['insert', ['link', 'picture', 'video']],
        ['misc', ['fullscreen', 'codeview']],
        ['misc', ['undo', 'redo']],
        ['misc', ['paste']],
        ['misc', ['help']],
      ],
    });

    if ($textarea.data('strip-formatting')) {
      $textareaWrapper.data('strip-formatting', true);
      $formGroup.find('.strip-formatting-button').addClass('active');
    }
    // https:// github.com/summernote/summernote/issues/282

    if (requried) {
      $formGroup
        .find('[contenteditable]')
        .attr({ id: `${id}_specialValidationInput`, name: `${id}_specialValidationInput` })
        .addClass('special-validation-input required');
    } else if (warning) {
      $formGroup
        .find('[contenteditable]')
        .attr({ id: `${id}_specialValidationInput`, name: `${id}_specialValidationInput` })
        .addClass('special-validation-input')
        .data('empty-warning', true)
        .attr('data-empty-warning', 'true');
    } else {
      $formGroup
        .find('[contenteditable]')
        .attr({ id: `${id}_specialValidationInput`, name: `${id}_specialValidationInput` })
        .addClass('special-validation-input');
    }

    if (readOnly) {
      ($textarea as any).summernote('disable');
    }
  });
}
